<template>
  <v-row justify="center">
    <v-dialog v-model="active" max-width="400">
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          您已產生繳費帳號
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; height:80px; font-size:15px">
          <span>請使用您的專屬ATM、銀行郵局臨櫃繳款帳號進行繳費</span><span class="pa-1" style="color:#F00; font-size:18px; font-height:50px">{{num}}</span>
        </v-card-text>
        <v-row justify="center">
          <v-card-actions>
            <v-btn outlined color="#FFF" style="width: 150px; height:46px; border-radius: 10px; background:#81C0E2"
            @click="save">
              確定
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'ShowMsgAtm',
    props:['onSave'],
    data () {
      return {
        active: false,
        num: '',
        onSaveEn: false,
      }
    },
    methods:{
      open(num = null,onSaveEn = false){
        this.active = true
        this.num = num
        this.onSaveEn = onSaveEn
      },
      close(){
        this.active = false
      },
      save(){
        if(this.onSaveEn){
          this.onSave()
        }
        this.close()
      }
    }
  }
</script>